<div class="p-10">
  <a routerLink="/"
    class="inline-flex items-center text-sm text-gray-500 transition-colors hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300">
    <!-- Text logo -->
    <div class="flex items-center gap-3">
      <!-- Shield Icon -->
      <img class="h-10 w-10" src="/images/logo/shield.svg" alt="AbuseXense Shield Logo" />

      <!-- Logo Text -->
      <div class="flex flex-col leading-tight">
        <div class="flex items-baseline">
          <span class="font-extrabold text-gray-900 dark:text-white text-lg">
            Abuse
          </span>
          <span
            class="font-extrabold text-lg bg-gradient-to-r from-[#83B1FF] to-[#5C77FF] bg-clip-text text-transparent">
            Xense
          </span>
        </div>
      </div>
    </div>
  </a>
</div>

<div class="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
  <div>
    @if (showEmailOtpPrompt) {
    <app-email-otp-prompt [loading]="isVerifyingEmailOtp" [errorMessage]="emailOtpError" [emailHint]="emailOtpDisplayTarget"
      [expiresInSeconds]="emailOtpExpiresInSeconds"
      [resendCooldownSeconds]="emailOtpResendCooldownSeconds"
      [sendSucceeded]="emailOtpExpiresInSeconds != null"
      (codeSubmit)="onEmailOtpSubmit($event)" (back)="onEmailOtpBack()" (resend)="onEmailOtpResend()" />
    } @else if (showTwoFactorPrompt) {
    <app-two-factor-prompt [loading]="isVerifyingTwoFactor" [errorMessage]="twoFactorError" [emailHint]="email"
      (codeSubmit)="onTwoFactorSubmit($event)" (back)="onTwoFactorBack()" />
    } @else if (showForgotPassword) {
    <!-- Forgot Password Form -->
    <div class="mb-5 sm:mb-8">
      <h1 class="mb-2 font-semibold text-gray-800 text-center text-title-sm dark:text-white/90 sm:text-title-md">
        Forgot Password?
      </h1>
      <p class="text-sm text-center text-gray-600 dark:text-gray-400">
        A verification link will be sent to your email address.
      </p>
    </div>

    <form (ngSubmit)="onForgotPasswordSubmit()" class="space-y-6">
      <div>
        <app-label>Email <span class="text-error-500">*</span></app-label>
        <app-input-field type="email" placeholder="Enter your email" [value]="forgotPasswordEmail"
          (valueChange)="forgotPasswordEmail = $event.toString()" name="forgotPasswordEmail" class="form-input" required
          [disabled]="isSubmittingForgotPassword" />
      </div>

      <app-button className="w-full" size="sm" (btnClick)="onForgotPasswordSubmit()"
        [disabled]="isSubmittingForgotPassword">
        @if (isSubmittingForgotPassword) {
        <span class="flex items-center gap-2">
          <span class="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
          Sending...
        </span>
        } @else {
        Send Reset Link
        }
      </app-button>

      <div class="mt-4 flex justify-center">
        <button type="button" (click)="onForgotPasswordBack()"
          class="inline-flex items-center justify-center gap-2 text-sm leading-none text-brand-500 hover:text-brand-600 dark:text-brand-400"
          [disabled]="isSubmitting">
          <i class="bi bi-arrow-left self-center text-base"></i>
          <span class="self-center leading-none">Back to Login</span>
        </button>
      </div>
    </form>
    } @else {
    <div class="mb-5 sm:mb-8">
      <h1 class="mb-2 font-semibold text-gray-800 text-center text-title-sm dark:text-white/90 sm:text-title-md">
        Welcome Back!
      </h1>
      @if (firstLoginInfo) {
      <p class="text-sm text-center text-blue-600 dark:text-blue-400">
        {{ firstLoginInfo }}
      </p>
      }
      @if (firstLoginError) {
      <p class="mt-2 text-sm text-center text-red-600 dark:text-red-400">
        {{ firstLoginError }}
      </p>
      }
    </div>

    <!-- Form -->
    <form (keyup.enter)="onSignIn()" (ngSubmit)="onSignIn()" class="space-y-6">
      <div>
        <app-label>Username/Email <span class="text-error-500">*</span></app-label>
        <app-input-field type="email" placeholder="Enter your username or email" [value]="email"
          (valueChange)="email = $event.toString()" name="email" class="form-input" required
          [disabled]="isSubmitting" />
      </div>

      <div>
        <app-label>Password <span class="text-error-500">*</span></app-label>
        <app-input-field type="password" placeholder="Enter your password" [value]="password"
          (valueChange)="password = $event.toString()" name="password" class="form-input" required
          [disabled]="isSubmitting" />
      </div>

      <div class="flex items-center justify-between">
        <button type="button" (click)="onForgotPasswordClick()"
          class="text-sm text-brand-500 hover:text-brand-600 dark:text-brand-400" [disabled]="isSubmitting">
          Forgot password?
        </button>
      </div>

      <app-button className="w-full" size="sm" (btnClick)="onSignIn()" [disabled]="isSubmitting">
        @if (isSubmitting) {
        <span class="flex items-center gap-2">
          <span class="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
          Signing in...
        </span>
        } @else {
        Login
        }
      </app-button>
    </form>

    <!-- <div class="mt-5">
          <p class="text-sm font-normal text-center text-gray-700 dark:text-gray-400 sm:text-center">
            Don't have an account?
            <a
              routerLink="/signup"
              class="text-brand-500 hover:text-brand-600 dark:text-brand-400"
            >
              Register Now.
            </a>
          </p>
        </div> -->
    }

  </div>
</div>